var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40065 15.1668H4.60065C1.99398 15.1668 0.833984 14.0068 0.833984 11.4002V8.60016C0.833984 5.9935 1.99398 4.8335 4.60065 4.8335H7.40065C10.0073 4.8335 11.1673 5.9935 11.1673 8.60016V11.4002C11.1673 14.0068 10.0073 15.1668 7.40065 15.1668ZM4.60065 5.8335C2.53398 5.8335 1.83398 6.5335 1.83398 8.60016V11.4002C1.83398 13.4668 2.53398 14.1668 4.60065 14.1668H7.40065C9.46732 14.1668 10.1673 13.4668 10.1673 11.4002V8.60016C10.1673 6.5335 9.46732 5.8335 7.40065 5.8335H4.60065Z",
    fill: "#172B85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4007 11.1668H10.6673C10.394 11.1668 10.1673 10.9402 10.1673 10.6668V8.60016C10.1673 6.5335 9.46732 5.8335 7.40065 5.8335H5.33398C5.06065 5.8335 4.83398 5.60683 4.83398 5.3335V4.60016C4.83398 1.9935 5.99398 0.833496 8.60065 0.833496H11.4007C14.0073 0.833496 15.1673 1.9935 15.1673 4.60016V7.40016C15.1673 10.0068 14.0073 11.1668 11.4007 11.1668ZM11.1673 10.1668H11.4007C13.4673 10.1668 14.1673 9.46683 14.1673 7.40016V4.60016C14.1673 2.5335 13.4673 1.8335 11.4007 1.8335H8.60065C6.53398 1.8335 5.83398 2.5335 5.83398 4.60016V4.8335H7.40065C10.0073 4.8335 11.1673 5.9935 11.1673 8.60016V10.1668Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.7436786e49b940355a8e91c0ec0c00d9.svg";
export { ForwardRef as ReactComponent };